import React from 'react';
import { Box, Button, HStack, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const RegisterNewDomainHeader = ({
  domainCreating,
  handleRegisterDomainClick
}) => (
  <Box borderBottom="1px solid" borderBottomColor="greyScale.200" p={8}>
    <HStack justifyContent="space-between">
      <Box pr={12} textAlign="left">
        <Text mb={4} textStyle="bodyMd500">Register Your Domain with PINS</Text>
        <Text color="greyScale.500" mb={2} textStyle="bodySm">
          By registering your domain, PINS can safely use your domain to send emails and satisfy DMARC compliance, increasing the
          likelihood of PINS emails reaching recipients&apos; inboxes and providing a better experience for your insureds and their agents.
        </Text>
        <Text color="greyScale.500" textStyle="bodySm">
          Please note: the registration process will require access to your domain&apos;s zone file.
        </Text>
      </Box>
      <Box>
        <Button
          isLoading={domainCreating}
          variant="primary"
          onClick={handleRegisterDomainClick}
        >
          Register Domain
        </Button>
      </Box>
    </HStack>
  </Box>
);

RegisterNewDomainHeader.propTypes = {
  domainCreating: PropTypes.bool,
  handleRegisterDomainClick: PropTypes.func
};

export default RegisterNewDomainHeader;
